exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column-options[data-v-29ad6ae4] {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n.column-option[data-v-29ad6ae4] {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 400;\n  margin: 0;\n  cursor: pointer;\n}", ""]);

// exports
